module.exports = __webpack_public_path__ + "img/物料费明细表示例.be3a8b0d.png";